// COPY-Button der Skript-Köpfe (TTSView, STSView, FreeChoiceView).
//
// Kopiert `text` in die Zwischenablage und zeigt 1,5 s lang „COPIED" mit
// Phosphor-Haken (vorher `✓ COPIED` als Unicode-Symbol — Projektregel: nur
// Phosphor). Abgelehnte Zwischenablage bleibt still, wie bisher an allen
// drei Stellen. Die Optik (Pill-Rahmen, Breite) kommt weiter aus dem
// CSS-Modul des Aufrufers über `className` / `copiedClassName`.

import { useCallback, useEffect, useRef, useState } from 'react';
import styles from './CopyButton.module.css';

export const COPIED_FEEDBACK_MS = 1500;

interface CopyButtonProps {
  text: string;
  className: string;
  copiedClassName: string;
  disabled?: boolean;
}

export function CopyButton({ text, className, copiedClassName, disabled }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | null>(null);
  useEffect(() => () => {
    if (timerRef.current != null) window.clearTimeout(timerRef.current);
  }, []);

  const onCopy = useCallback(() => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(true);
        if (timerRef.current != null) window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
      },
      () => { /* clipboard rejected — silent */ },
    );
  }, [text]);

  return (
    <button
      type="button"
      className={`${className} ${copied ? copiedClassName : ''}`}
      onClick={onCopy}
      disabled={disabled}
      tabIndex={-1}
    >
      {copied ? (
        <>
          <i className={`ph-bold ph-check ${styles.icon}`} aria-hidden="true" />
          COPIED
        </>
      ) : (
        'COPY'
      )}
    </button>
  );
}
